import React, { useState, useEffect } from "react";
import { Grid, Typography, Box } from "@mui/material";
import publicTransport from "../../../../assets/SvgIcons/publictransport.svg";
import parkingImg from "../../../../assets/SvgIcons/icons-copy-9-parking.svg";
import Card from "../Common/Card";
import CustomBox from "../Common/CustomBox";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import LitigantBox from "../Common/LitigantBox";
import GettingThereDonnetChart from "../Common/GettingThereDonnetChart.js";
import { District } from "../../../../utils/Constants.js";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import { BlockGridGraph } from "../BuildingBetterCourtsData.js";

let cardDataStatic = [
  {
    icon: publicTransport,
    content: "Accessible via Public Transport",
    statistics: "81%",
  },
  {
    icon: parkingImg,
    content: "Parking Availability",
    statistics: "80%",
  },
];

let faqsStatic = [
  {
    content: "Is there designated parking?",
    status: "Yes",
  },
  {
    content: "Is the court accessible via public transport?",
    status: "Yes",
  },
];

const numberValue = (value) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const matchesCommuteValues = (current, expected) =>
  current.length === expected.length && current.every((value, index) => value === expected[index]);

const legacyCommuteOverrides = {
  "Assam|Baksa": {
    current: [4, 35, 40, 51],
    legacy: [20, 80, 0, 0],
  },
};

const commuteDataFor = (data = {}) => {
  const current = [
    numberValue(data?.public_transport),
    numberValue(data?.private_transport),
    numberValue(data?.walking),
    numberValue(data?.others),
  ];
  const override = legacyCommuteOverrides[`${data?.state}|${data?.district_name}`];
  return override && matchesCommuteValues(current, override.current) ? override.legacy : current;
};

export const GettingThere = ({ dataState, dataDistrict, selectedDistrict }) => {
  const { theme, loader } = useCustomLogic();
  const [cardData, setCardData] = useState(cardDataStatic);
  const [faqs, setFaqs] = useState(faqsStatic);
  const [donnetData, setDonnetData] = useState([]);
  const [dotGraphKey, setDotGraphKey] = useState(1);

  let isDistrict = selectedDistrict === "Select District";

  useEffect(() => {
    if (dataState && Object.keys(dataState).length > 0) {
      let arr = [dataState.access_via_public_transport ?? 0, dataState.parking_available ?? 0];
      setCardData(
        cardDataStatic.map((item, index) => ({
          ...item,
          statistics: `${arr[index]}%`,
        }))
      );

      setDonnetData(commuteDataFor(dataState));
    }
    if (dataDistrict && Object.keys(dataDistrict).length > 0) {
      // let arr = Object.values(dataDistrict).slice(2);
      let arr = [dataDistrict?.parking_present, dataDistrict?.accessible_via_public_transport];

      setFaqs(
        faqs.map((item, index) => ({
          ...item,
          status: arr[index],
        }))
      );

      setDonnetData(commuteDataFor(dataDistrict));
    }
    if (isDistrict) {
      setDonnetData(commuteDataFor(dataState));
    }
    setDotGraphKey(Math.random());
  }, [dataState, dataDistrict, selectedDistrict]);

  return (
    <>
      {loader ? (
        <LoaderComponent height={"50vh"} />
      ) : (
        <Box>
          <Typography variant="regular3" color="secondary.main">
            How easy is it to reach the court complex?
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: "10px",
              textAlign: "left",
              letterSpacing: "0.2px",
              wordSpacing: "1px",
            }}
          >
            Litigants were asked how they travelled to the court complex. While scoring, priority
            was given to accessibility via public transport. If a person visits a court complex by a
            private vehicle, priority was given to complexes that had parking facility.
          </Typography>
          <CustomBox
            content={
              isDistrict
                ? "ACCESSIBILITY TO THE COURT COMPLEX:"
                : "Is it easy to reach the court complex?"
            }
            style={{
              fontSize: !isDistrict && "24px",
              padding: !isDistrict && "8px 13px",
              color: !isDistrict && theme.palette.common.black,
              backgroundColor: !isDistrict && "#e6ebf4",
            }}
          />
          {isDistrict ? (
            <Grid
              container
              lg={12}
              md={12}
              spacing={2}
              sx={{ padding: "0 !important", marginBottom: "20px" }}
            >
              {cardData.map((elem) => (
                <Grid item xs={12} md={6} lg={6} key={elem.content}>
                  <BlockGridGraph percentage={elem?.statistics} color="#00bcd4" />
                  <Card imgSrc={elem.icon} content={elem.content} statistics={elem.statistics} />
                </Grid>
              ))}
            </Grid>
          ) : (
            faqs.map((elem, index) => (
              <>
                <FAQ
                  key={elem.content}
                  content={elem.content}
                  status={elem.status}
                  isLastItem={index === faqs.length - 1}
                />
              </>
            ))
          )}
          <LitigantBox mt={!isDistrict && "26px"} mb={!isDistrict && "0px"} />
          <CustomBox
            mt={!isDistrict && "0px"}
            mb="20px"
            content="HOW DID LITIGANTS COMMUTE TO COURT?"
          />

          {donnetData.length > 0 ? (
            <GettingThereDonnetChart data={donnetData} key={dotGraphKey} />
          ) : null}
        </Box>
      )}
    </>
  );
};

export default GettingThere;
